import { ABTestVariation, MagicVariables } from '@/types';
import { TrackVideoClick } from './track_video_click';
import { getCookie } from '@/utils/cookie';

export class SearchPage implements MagicVariables {
    $root: MagicVariables['$root'];
    trackVideoClick: TrackVideoClick;

    constructor(trackVideoClick: TrackVideoClick) {
        this.trackVideoClick = trackVideoClick;
    }

    init() {
        if (this.shouldTrackVideoClick()) {
            this.trackVideoClick.init(this.$root);
        }
    }

    shouldTrackVideoClick(): boolean {
        try {
            const searchPageVariationCookie = getCookie('search_page_variation_v3');
            const variation = parseInt(searchPageVariationCookie, 10) as ABTestVariation;

            return variation === ABTestVariation.CONTROL || variation === ABTestVariation.TREATMENT;
        } catch (_) {
            return false;
        }
    }
}
